import axios from 'axios';
import TokenInterceptor from '../interceptors/token';
import rebrand from '../../../config/rebrand';

const API_ENDPOINT = rebrand.urls.API_ENDPOINT;

let instance;

export default () => {
  if (instance) {
    return instance;
  }

  instance = axios.create(
    { baseURL: API_ENDPOINT },
  );

  instance.interceptors.response.use(response => response, TokenInterceptor(instance));

  return instance;
};



// WEBPACK FOOTER //
// ./src/services/request/api/instance.js